
import React from 'react'
import { useSelector } from 'react-redux'
import { IComponent } from '../../utils/type/dynamic-rendering.interfaces'
import { getActiveSection } from '../../store/selectors/selectors'
import { DistributeComponents } from '../DistributeComponents/DistributeComponents'

export const SectionsParams = () => {

    let settings: IComponent[] = useSelector(getActiveSection);
    console.log(settings);

    return (<>

        <>
            {
                settings && settings.map((setting: IComponent) => {
                    return (<DistributeComponents key={setting['data']['id']} {...setting} />)
                })
            }

        </>
    </>
    )
}
